export default __webpack_public_path__ + "static/media/orangeMedium.986861d7.svg";